import moment from "moment";

export const PUSHER_CHANNEL_NAME = process.env.REACT_APP_PUSHER_CHANNEL_NAME;
export const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER;
export const PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
export const BATCH_API = process.env.REACT_APP_BATCH_API;

export const today = moment().format('YYYY-MM-DD');

export const ADMIN_CASE_ROLE_FILTER = 'admin, admin-port, manager, dec-executive, dec-executive-port, sales-executive';
export const DEC_CASE_ROLE_FILTER = 'dec-executive, dec-executive-port';

export const ADMIN_QUOTATION_ROLE_FILTER = 'admin, manager, sales-executive';
export const FIRST_SECOND_CONTACT_FILTER = 'first-contact-executive, sales-executive-sc, purchase-advisor-sc';

export const FIRST_SECOND_CONTACT = ['first-contact-executive', 'sales-executive-sc', 'purchase-advisor-sc'];
export const FIRST_SECOND_EXECUTIVES = ['first-contact-executive', 'sales-executive-sc', 'admin'];
export const SECOND_ADVISOR = ['purchase-advisor-sc', 'admin'];
export const SECOND_EXECUTIVE = ['sales-executive-sc', 'admin'];

export const ROLES = {
  admin: 'admin',
  adminPort: 'admin-port',
  manager: 'manager',
  decExecutive: 'dec-executive',
  decExecutivePort: 'dec-executive-port',
  salesExecutive: 'sales-executive',
  salesExecutivePort: 'sales-executive-port',
  firstContactExecutive: 'first-contact-executive',
  salesExecutiveSc: 'sales-executive-sc',
  purchaseAdvisorSc: 'purchase-advisor-sc',
  refinancing: 'dec-executive-refinancing',
  auditor: 'auditor',
};

export const refinancingAllowedList = ['admin', 'manager', 'dec-executive-refinancing'];
export const casesAllowedList = ['admin', 'admin-port', 'manager', 'dec-executive', 'dec-executive-port', 'dec-executive-refinancing', 'auditor'];

export const vehicleTypeList = [
  { id: 1, label: 'Automóvil', value: 'auto' },
  { id: 5, label: 'Motocicleta', value: 'moto' },
  { id: 2, label: 'Camión', value: 'camion' },
  { id: 11, label: 'Bus - Minibus', value: 'bus' },
];

export const channels = [
  { id: 1, label: 'Dealer Propio' },
  { id: 2, label: 'Chileautos' },
  { id: 3, label: 'YAPO' },
  { id: 4, label: 'Facebook' },
  { id: 5, label: 'Particular' },
  { id: 6, label: 'Dealer Nuevo' },
  { id: 7, label: 'Dealer Usado' },
  { id: 8, label: 'Otro' },
];

export const scoreOptions = [
  { id: 1, label: 'Acepta lo solicitado', value: 'Acepta lo solicitado' },
  { id: 2, label: 'Acepta parcialmente lo solicitado', value: 'Acepta parcialmente lo solicitado' },
  { id: 3, label: 'Rechaza lo solicitado', value: 'Rechaza lo solicitado' },
];

// constantes nuevas gestiones
export const before30 = 'before 30';
export const after30 = 'after 30';
export const needsOffert = 'Solicita nueva oferta';

export const optionsPropierty = [
  { value: true, label: 'Si' },
  { value: false, label: 'No' },
];

export const optionsOrigin = [
  { value: 'phone', label: 'Teléfono' },
  // { value: 'web', label: 'Web' },
  { value: 'referred', label: 'Referido' },
  { value: 'face', label: 'Presencial' },
  { value: 'trinidad', label: 'Trinidad' },
  { value: 'spider', label: 'Spider' },
];

export const optionsSituation = [
  { value: 'dependent', label: 'Dependiente' },
  { value: 'independent', label: 'Independiente' },
];

export const optionsContrats = [
  { value: 'fixedTerm', label: 'Plazo fijo' },
  { value: 'undefined', label: 'Indefinido' },
];


export const optionsTypes = [
  { value: 'dependent', label: 'Dependiente' },
  { value: 'independent', label: 'Independiente' },
  { value: 'company', label: 'Empresa' },
];